module.exports = __webpack_public_path__ + "static/media/persona_moral.ce1724b9.svg";